module.exports = __webpack_public_path__ + "static/4-46a7d48240d428c9dc3d4ff579199312.woff";